// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-holiday__items":"jobSearchDetail-holiday__items"};